import React from 'react';
import { StyledBadge } from './styles.js';

var defaultValueVariation = 'primary';
var Badge = function (_a) {
    var children = _a.children, _b = _a.variation, variation = _b === void 0 ? defaultValueVariation : _b, pill = _a.pill;
    return (React.createElement(StyledBadge, { variation: variation, pill: pill }, children));
};

export { Badge as default, defaultValueVariation };
